/* global $ */
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { displayNotification, sendAPIRequest } from "helpers";
import { fetchReportLists } from "../../../redux/reportSlice";
import TextAreaField from "../../core/TextAreaField";
import { FaCheck, FaEdit } from "react-icons/fa";
import { Button } from "@mui/material";

const FormTableListModal = (props) => {
    const dispatch = useDispatch();
    const el = useRef();
    const formTableLists = useSelector((state) => state.report.lists);

    const [mode, setMode] = useState("new");
    const [listID, setListID] = useState("");
    const [form, setForm] = useState({ id: "", name: "", relatedList: "" });
    const [temp, setTemp] = useState({ value: "" });
    const [entries, setEntries] = useState([]);

    const openModal = (mode = "new", list_id) => {
        $(el.current).modal("show");
        setMode(mode);
        if (mode == "edit" && list_id != "") {
            setListID(list_id);
            loadData(list_id);
        }
    };

    const closeModal = (data) => {
        setForm({ name: "", relatedList: "" });
        setTemp({ value: "" });
        setEntries([]);
        setMode("new");
        setListID("");
        $(el.current).modal("hide");
        if (data != null) {
            dispatch(fetchReportLists("template", props.templateID));
        }
    };

    const loadData = (list_id) => {
        sendAPIRequest(`/api/pvsa/form-table-lists/${list_id}`)
            .then((data) => data.json())
            .then((ret) => {
                if (ret.success) {
                    setForm({ ...form, name: ret.data.name, id: ret.data.id });
                    setEntries(ret.entries);
                } else {
                    displayNotification("error", "Error loading Form Table List Data [B]");
                }
            })
            .catch((e) => {
                displayNotification("error", "Error loading Form Table List Data [F]");
                console.log(e);
            });
    };

    const handleSave = async () => {
        try {
            if (form.name == "") {
                displayNotification("warning", "Please fill name field before saving.");
                return;
            }
            if (entries.length == 0) {
                displayNotification("warning", "Please add at least 1 list value before saving.");
                return;
            }
            let url = `/api/pvsa/form-table-lists`;
            let options = {
                method: "POST",
                body: {
                    ...form,
                    template_id: props.templateID,
                    values: entries,
                },
            };
            if (mode == "edit") {
                url = `/api/pvsa/form-table-lists/${form.id}`;
                options.body = { ...form, _method: "PUT" };
            }
            const req = await sendAPIRequest(url, options.method, options.body);
            const ret = await req.json();
            if (ret.success) {
                closeModal(ret.data);
                props.onListUpdate();
                displayNotification("success", "Successfully Saved Form Table List");
            } else {
                displayNotification("error", "Error saving List Data [B]");
            }
        } catch (e) {
            displayNotification("error", "Error saving List Data [F]");
            console.error({ e });
        }
    };

    const handleDelete = async (elID) => {
        try {
            if (window.confirm("Are you sure?")) {
                const req = await sendAPIRequest(`/api/pvsa/form-table-list-elements/${elID}?_method=DELETE`, "POST");
                const ret = await req.json();
                if (ret.success) {
                    loadData(listID);
                    props.onListUpdate();
                    displayNotification("success", "Successfully Deleted List Element");
                } else {
                    displayNotification("error", "Error deleting List Element [B]");
                }
            }
        } catch (e) {
            displayNotification("error", "Error deleting List Element [F]");
            console.error({e});
        }
    };

    const handleAddNewEntryAction = async () => {
        try {
            if (temp.value == "") {
                displayNotification("warning", "Value field cannot be empty.");
            } else {
                if (mode == "new") {
                    let ent = entries;
                    ent.push({
                        id: Math.floor(Math.random() * 100),
                        value: temp.value,
                    });
                    setEntries(ent);
                    setTemp({ value: "" });
                    displayNotification("success", "Successfully added value to the list");
                } else {
                    const req = await sendAPIRequest(`/api/pvsa/form-table-list-elements`, "POST", {
                        ...temp,
                        form_table_list_id: listID,
                    });
                    const ret = await req.json();
                    if (ret.success) {
                        setTemp({ value: "" });
                        loadData(listID);
                        props.onListUpdate();
                        displayNotification("success", "Successfully added List Element");
                    } else {
                        displayNotification("error", "Error adding List Element [B]");
                    }
                }
            }
        } catch (e) {
            displayNotification("error", "Error adding List Element [F]");
            console.error({e});
        }
    };

    const generateRelatedListValues = (relatedListId) => {
        if (relatedListId !== "") {
            const relatedList = formTableLists?.find((r) => r.id == relatedListId);
            if (relatedList !== undefined) {
                let ent = [];
                for (let x in relatedList.relation_elements) {
                    ent.push({
                        id: Math.floor(Math.random() * 100),
                        related_column_value: relatedList.relation_elements[x].value,
                        value: "",
                    });
                }
                setEntries(ent);
            }
        }
    };

    const validateValues = () => {
        if (entries.length == 0) return true;
        for (let x in entries) {
            if (entries[x].value == "") {
                return true;
            }
        }
        return false;
    };

    const handleChangeEntryValue = (key, val) => {
        let ent = [...entries];
        ent[key].value = val;
        setEntries(ent);
    };

    return (
        <>
            {props.showDropdown ? (
                <div className="input-group">
                    <select className="form-control" value={props.value} onChange={(e) => props.onChange(e)}>
                        <option value="">None</option>
                        {formTableLists?.map((lst) => {
                            return (
                                <option value={lst.id} key={lst.id}>
                                    {lst.id >= 0 && `[${lst.id}]`} {lst.name}
                                </option>
                            );
                        })}
                    </select>
                    <div className="input-group-append">
                        <button className="btn btn-primary btn-sm min-w-10px" onClick={() => openModal()}>
                            <i className="fas fa-plus pr-0"></i>
                        </button>
                    </div>
                    {props.value != "" && props.value >= 0 && (
                        <div className="input-group-append">
                            <button
                                className="btn btn-warning btn-sm min-w-10px"
                                onClick={() => openModal("edit", props.value)}
                            >
                                <i className="fas fa-edit pr-0"></i>
                            </button>
                        </div>
                    )}
                </div>
            ) : (
                <Button
                    variant="contained"
                    color="primary"
                    disableElevation={true}
                    title={"Edit List"}
                    onClick={() => openModal("edit", props.value)}
                >
                    <FaEdit style={{ marginRight: "3px" }} />
                    <span>Edit List</span>
                </Button>
            )}
            <div className="modal fade" ref={el}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header p-4">
                            <h4 className="modal-title">
                                {mode == "new" ? "New" : "Edit"} List {!props.listNameEditable ? `(${form.name})` : ""}
                            </h4>
                            <button type="button" className="close" onClick={() => closeModal()}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-body p-4">
                            {
                                (props.listNameEditable || (mode == "new" && props.formType == "static_list_text" && mode == "new")) && (
                                    <>
                                        <div className="row">
                                            {props.listNameEditable && (
                                                <div className="col">
                                                    <TextAreaField
                                                        label={"List Name"}
                                                        type={"text"}
                                                        value={form.name}
                                                        onChange={(val) =>
                                                            setForm({
                                                                ...form,
                                                                name: val,
                                                            })
                                                        }
                                                        onBlur={() => {}}
                                                        error={false}
                                                    />
                                                </div>
                                            )}
                                            {mode == "new" && props.formType == "static_list_text" && mode == "new" && (
                                                <div className="col-md-4 col-sm-6 col-12">
                                                    <div className="form-group">
                                                        <label>Related List</label>
                                                        <select
                                                            className="form-control"
                                                            value={form.relatedList}
                                                            onChange={(e) => (
                                                                setForm({
                                                                    ...form,
                                                                    relatedList: e.target.value,
                                                                }),
                                                                generateRelatedListValues(e.target.value)
                                                            )}
                                                        >
                                                            <option value="">Select</option>
                                                            {formTableLists?.map((list) => (
                                                                <option value={list.id} key={list.id}>
                                                                    {list.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <hr />
                                    </>
                                )
                            }
                            {!(props.formType == "static_list_text" && mode == "new") && (
                                <div className="row">
                                    <div className="col">
                                        <div className="row mb-2">
                                            <div className="col-md-9 col-sm-8 col-12">
                                                <TextAreaField
                                                    label={"Enter Value"}
                                                    type={"text"}
                                                    value={temp.value}
                                                    onChange={(val) =>
                                                        setTemp({
                                                            value: val,
                                                        })
                                                    }
                                                    size={'small'}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-4 col-12">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disableElevation={true}
                                                    className="w-100 h-100"
                                                    title="Add to List"
                                                    onClick={handleAddNewEntryAction}
                                                >
                                                    <FaCheck style={{ marginRight: "3px" }} />
                                                    <span>Add to List</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="bg-primary text-white">
                                        <tr>
                                            <td width="30%">#</td>
                                            {props.formType == "static_list_text" && mode == "new" && (
                                                <td>Related Value</td>
                                            )}
                                            <td>Value</td>
                                            {mode == "edit" && <th></th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {entries.map((val, key) => {
                                            return (
                                                <tr key={val.id}>
                                                    <td width="30%">{key + 1}</td>
                                                    {props.formType == "static_list_text" && mode == "new" && (
                                                        <td>{val.related_column_value}</td>
                                                    )}
                                                    <td>
                                                        {props.formType == "static_list_text" && mode == "new" ? (
                                                            <input
                                                                className="form-control"
                                                                placeholder="Enter value"
                                                                value={val.value}
                                                                onChange={(e) =>
                                                                    handleChangeEntryValue(key, e.target.value)
                                                                }
                                                            />
                                                        ) : (
                                                            val.value
                                                        )}
                                                    </td>
                                                    {mode == "edit" && (
                                                        <td>
                                                            <i
                                                                className="fas fa-trash-alt text-danger cursor-pointer"
                                                                onClick={() => handleDelete(val.id)}
                                                            />
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer px-4 py-2">
                            <Button
                                variant="contained"
                                color="success"
                                disableElevation={true}
                                title={mode == "edit" ? "Save & Close" : "Close"}
                                onClick={handleSave}
                                disabled={validateValues()}
                            >
                                <FaCheck style={{ marginRight: "3px" }} />
                                <span>Add to List</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

FormTableListModal.defaultProps = {
    showDropdown: true,
    listNameEditable: true,
    templateID: "",
    formType: "",
    value: "",
    onChange: () => {},
    onListUpdate: () => {},
};

export default FormTableListModal;
